import type { CaptureTargetView } from './CaptureViewTarget';

// ---- キャプチャ実装（useViewImageCapture）が throw する型付きエラー群 ----
// 呼び出し側（MCPBridgeMessageHandler / AIアシスタント）が catch して、それぞれの経路の
// 失敗表現へ変換する。

export class CaptureNotReadyError extends Error {
  constructor() {
    super('Image capture is not ready');
    this.name = 'CaptureNotReadyError';
  }
}

export class CapturePermissionDeniedError extends Error {
  constructor() {
    super('Image export is not permitted');
    this.name = 'CapturePermissionDeniedError';
  }
}

export class CaptureBusyError extends Error {
  constructor() {
    super('Another image capture is in progress');
    this.name = 'CaptureBusyError';
  }
}

export class CaptureViewNotFoundError extends Error {
  constructor(
    // 指定された viewId または viewName（どちらの指定でも一致なしはこのエラーになる）
    readonly specified: string,
    readonly views: CaptureTargetView[]
  ) {
    super(`View not found: ${specified}`);
    this.name = 'CaptureViewNotFoundError';
  }
}

export class CaptureViewNameAmbiguousError extends Error {
  constructor(
    readonly viewName: string,
    readonly candidates: CaptureTargetView[]
  ) {
    super(`View name is ambiguous: ${viewName}`);
    this.name = 'CaptureViewNameAmbiguousError';
  }
}

export class CapturePayloadTooLargeError extends Error {
  constructor(readonly base64Length: number) {
    super(`Captured image is too large to send: ${base64Length}`);
    this.name = 'CapturePayloadTooLargeError';
  }
}
